/**
 * Kalkulator tkanki tłuszczowej: widok.
 *
 * Wszystkie obliczenia robi body-fat-calculator-logic.js (window.DnnzBodyFatLogic).
 * Ten plik niczego nie dorenderowuje: tabelka przykładów, panel wyniku,
 * blokady i teksty stoją w źródle HTML. Tutaj dzieje się tylko odczyt pól,
 * przełączanie stanów, wstawianie liczb w zdania z atrybutów data-text-*
 * i przyklejany pasek nawigacji.
 *
 * Konfigurację (liczby) skrypt czyta z atrybutu data-config sekcji, który
 * szablon wypełnia z inc/data/body-fat.php. Stan nie jest nigdzie zapisywany.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function fill(template, values) {
		return String(template || '').replace(/\{([a-z0-9]+)\}/g, function (match, key) {
			return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
		});
	}

	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	function initCalculator(root, L) {
		var cfg;
		try {
			cfg = JSON.parse(root.getAttribute('data-config'));
		} catch (e) {
			return;
		}

		var q = function (selector) {
			return root.querySelector(selector);
		};
		var qa = function (selector) {
			return Array.prototype.slice.call(root.querySelectorAll(selector));
		};

		var sexInputs = qa('[data-role="sex"]');
		var KEYS = ['age', 'height', 'weight', 'waist'];
		var numbers = {};
		var ranges = {};
		var fills = {};
		var errors = {};
		KEYS.forEach(function (key) {
			numbers[key] = q('[data-role="' + key + '-number"]');
			ranges[key] = q('[data-role="' + key + '-range"]');
			fills[key] = q('[data-role="' + key + '-fill"]');
			errors[key] = q('[data-role="' + key + '-error"]');
		});

		var states = {};
		['empty', 'value', 'minor', 'impossible'].forEach(function (name) {
			states[name] = q('[data-state="' + name + '"]');
		});
		var valueState = states.value;
		var bfEl = q('[data-role="bf"]');
		var rangeText = q('[data-role="range-text"]');
		var scale = q('[data-role="scale"]');
		var scaleBar = q('[data-role="scale-bar"]');
		var marker = q('[data-role="marker"]');
		var composition = q('[data-role="composition"]');
		var weightPrompt = q('[data-role="weight-prompt"]');
		var fatEl = q('[data-role="fat"]');
		var leanEl = q('[data-role="lean"]');
		var ffmiEl = q('[data-role="ffmi"]');
		var normLine = q('[data-role="ffmi-norm-line"]');
		var normEl = q('[data-role="ffmi-norm"]');
		var bridgeExcess = q('[data-bridge="excess"]');
		var excessEl = q('[data-role="excess"]');
		var lossLink = q('[data-role="loss-link"]');
		var protein = q('[data-role="protein"]');
		var liveEl = q('[data-role="live"]');

		if (!numbers.height || !states.empty || !valueState) {
			return;
		}

		// Odświeżenie strony = stan wyjściowy: przeglądarki potrafią przywrócić
		// wpisane wartości, więc na starcie jawnie wracamy do wartości z HTML.
		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].value = numbers[key].defaultValue;
			}
		});
		sexInputs.forEach(function (input) {
			if (input) {
				input.checked = input.defaultChecked;
			}
		});

		function text(name) {
			return valueState.getAttribute('data-text-' + name) || '';
		}

		function checkedValue(inputs, fallback) {
			for (var i = 0; i < inputs.length; i++) {
				if (inputs[i].checked) {
					return inputs[i].value;
				}
			}
			return fallback;
		}

		/**
		 * Jedna linia pod liczbą: kategoria + zakres dla płci i wieku
		 * („Otyłość. Zakres dla mężczyzn 40–59 lat: 11–22%.”). Bez zakresu:
		 * kategoria (tylko otyłość da się ustalić bez wieku) + zdanie o wieku.
		 */
		function rangeLine(state) {
			var label = state.category ? valueState.getAttribute('data-label-' + state.category) || '' : '';
			var rest;
			if (state.range) {
				var r = state.range;
				rest = fill(text('range'), {
					grupa: valueState.getAttribute('data-group-' + state.sex) || '',
					a: r.age_min,
					b: r.age_max,
					low: r.low,
					high: r.high
				});
			} else {
				rest = text(state.rangeNote === 'no-age' ? 'no-age' : 'out-of-range');
			}
			return label ? label + ' ' + rest : rest;
		}

		function updateScale(state) {
			var r = state.range;
			toggle(scale, !!r);
			if (!r) {
				return;
			}
			// Próg otyłości autorów RFM, bez podziału na wiek (DECYZJE D21).
			var obese = cfg.obesity[state.sex];
			var ticks = { low: r.low, high: r.high, obese: obese };
			var max = cfg.scale.max;
			var at = function (v) {
				return fillPercent(v, 0, max);
			};
			var widths = {
				low: at(r.low),
				normal: at(r.high) - at(r.low),
				high: at(obese) - at(r.high),
				obese: 100 - at(obese)
			};
			Object.keys(widths).forEach(function (seg) {
				var el = scale.querySelector('[data-seg="' + seg + '"]');
				if (el) {
					el.style.width = widths[seg] + '%';
				}
			});
			['low', 'high', 'obese'].forEach(function (tick) {
				var el = scale.querySelector('[data-tick="' + tick + '"]');
				if (el) {
					el.style.left = at(ticks[tick]) + '%';
					el.textContent = String(ticks[tick]);
				}
			});
			if (marker) {
				marker.style.left = at(Math.min(state.bf, max)) + '%';
			}
			if (scaleBar) {
				scaleBar.setAttribute('aria-label', fill(text('scale'), { low: r.low, high: r.high, obese: obese, bf: state.bf }));
			}
		}

		function updateComposition(state) {
			var c = state.composition;
			toggle(composition, !!c);
			toggle(weightPrompt, !c);
			if (!c) {
				return;
			}
			fatEl.textContent = L.formatDecimal(c.fat);
			leanEl.textContent = L.formatDecimal(c.lean);
			ffmiEl.textContent = L.formatDecimal(c.ffmi);
			toggle(normLine, c.ffmiNormalized !== null);
			if (c.ffmiNormalized !== null) {
				normEl.textContent = L.formatDecimal(c.ffmiNormalized);
			}
		}

		function render() {
			var sex = checkedValue(sexInputs, '');

			var input = { sex: sex };
			KEYS.forEach(function (key) {
				input[key] = numbers[key] ? numbers[key].value : '';
			});
			var state = L.evaluate(input, cfg);

			// Komunikaty przy polach.
			KEYS.forEach(function (key) {
				toggle(errors[key], state.fields[key].invalid);
			});

			// Suwak i pole liczbowe to jedna wartość w dwóch kontrolkach (wszystkie pola).
			var UNITS = { age: 'lat', height: 'cm', weight: 'kg', waist: 'cm' };
			KEYS.forEach(function (key) {
				var range = ranges[key];
				var field = state.fields[key];
				var limits = cfg.limits[key];
				if (!range) {
					return;
				}
				range.classList.toggle('is-empty', field.value === null);
				if (field.value !== null) {
					range.value = Math.min(limits.max, Math.max(limits.min, Math.round(field.value)));
					range.setAttribute('aria-valuetext', numbers[key].value.trim() + ' ' + UNITS[key]);
				} else {
					range.value = limits.min;
					range.setAttribute('aria-valuetext', 'nie podano');
				}
				if (fills[key]) {
					fills[key].style.width = field.value === null ? '0%' : fillPercent(field.value, limits.min, limits.max) + '%';
				}
			});

			var shown = state.blocked === 'minor' ? 'minor'
				: state.impossible ? 'impossible'
				: state.hasResult ? 'value' : 'empty';
			Object.keys(states).forEach(function (name) {
				toggle(states[name], name === shown);
			});

			var line = '';
			if (state.hasResult) {
				bfEl.textContent = String(state.bf);
				line = rangeLine(state);
				rangeText.textContent = line;
				updateScale(state);
				updateComposition(state);

				var excess = state.excess !== null;
				toggle(bridgeExcess, excess);
				if (excess && excessEl) {
					excessEl.textContent = L.formatDecimal(state.excess);
				}
				toggle(lossLink, state.category === 'high' || state.category === 'obese');
				toggle(protein, state.proteinCta);
			}

			if (liveEl) {
				liveEl.textContent = state.hasResult ? fill(text('live'), { bf: state.bf }) + ' ' + line : '';
			}
		}

		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].addEventListener('input', render);
			}
			if (ranges[key]) {
				ranges[key].addEventListener('input', function () {
					numbers[key].value = ranges[key].value;
					render();
				});
			}
		});
		sexInputs.forEach(function (input) {
			if (input) {
				input.addEventListener('change', render);
			}
		});

		render();
	}

	/**
	 * Nawigacja kotwicowa dokleja się pod header motywu i jedzie z czytelnikiem
	 * do końca strony (jak w spalaniu i nawodnieniu: pozycję przełącza skrypt,
	 * bo position: sticky kończy się razem z sekcją bloku).
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'body-fat-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;
			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		function updateActive(offset) {
			if (!links.length) {
				return;
			}
			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;
			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});
			// Sekcja, która cała przewinęła się nad linię odczytu, oddaje
			// aktywność następnej (rozszerzenie skryptu spalania, jak w nawodnieniu).
			if (current !== -1 && targets[current].getBoundingClientRect().bottom < line) {
				for (var j = current + 1; j < targets.length; j++) {
					if (targets[j]) {
						current = j;
						break;
					}
				}
			}
			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}
			if (current === activeIndex) {
				return;
			}
			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}
			activeIndex = current;
			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;
			var offset = headerOffset();
			root.style.setProperty('--bf-sticky-top', offset + 'px');
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;
			if (!isFixed && top <= offset) {
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}
			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);
		update();
	}

	function init() {
		var L = window.DnnzBodyFatLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-body-fat]'));
		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
